var guidelines = ( function( $ ) {

	var $country_links;

	var _init = function() {
		$country_links = $( '.country-link' );

		if ( $country_links.length > 0 ) {
			_setup_country_links();
		}
	};

	var _setup_country_links = function() {
		$country_links.click( function( e ) {
			e.preventDefault();

			var destination_id = $( this ).attr( 'href' );

			$( "body,html" ).animate(
				{ scrollTop: $( destination_id ).offset().top },
				800
			);
		} )
	};

	if ( $( '#guidelines-content' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = guidelines;